PJQ.models.reports.Report = PJQ.models.BaseModel.extend({
    idAttribute: 'reportId',
    getExtraParameters: function (callback) {
        if (this.get('extraParameters') && !this.parameters) {
            this.parameters = new PJQ.collections.reports.ReportParameters();

            let extraParamsArray = this.get('extraParameters').split("|||");

            _.each(extraParamsArray, function (param, index) {
                let thisReportParam = param.split("||"),
                    parameterObject = new PJQ.models.reports.ReportParameter({
                        name: thisReportParam[0],
                        inputDisplayName: thisReportParam[1],
                        inputType: thisReportParam[2],
                        defaultValue: thisReportParam[4],
                        value: thisReportParam[4],
                        choices: []
                    }),
                    customField;

                let choices = [];
                if (parameterObject.get('inputType').toLowerCase() === 'select') {
                    let options = thisReportParam[3].split("|");

                    _.each(options, function (option) {
                        let splitOption = option.split(":")

                        // Check if custom field options exist
                        if (option.includes('ProjectCustomField:')) {
                            customField = new PJQ.models.projects.ProjectCustomField({
                                id: parseInt(splitOption[1])
                            })
                        } else if (option.includes('CompanyCustomField:')) {
                            customField = new PJQ.models.contacts.CompanyCustomField({
                                id: parseInt(splitOption[1])
                            })
                        } else if (option.includes('ContactCustomField:')) {
                            customField = new PJQ.models.contacts.ContactCustomField({
                                id: parseInt(splitOption[1])
                            })
                        } else if (option.includes('User:')) {
                            customField = new PJQ.collections.users.Users({})
                        } else {
                            choices.push(option);
                        }
                    }, this)

                    // Reused render function
                    let fnRender = _.bind(function () {
                        // Users uses a collection and not a model, so it needs to map through the models and not the choices
                        if (PJQ.helpers.objectHelpers.refinedType(customField, true) === 'backboneCollection') {
                            let customChoices = _.map(customField.models, function (model) {
                                return model.get('contactName');
                            }, this)

                            // If there are choices existing that aren't included in custom field choices, then push them
                            if (choices.length > 0) {
                                customChoices.unshift(...choices);
                            }

                            parameterObject.set('choices', customChoices);
                            // Custom fields use a model with a choices object
                        } else {
                            let customChoices = _.map(customField.choices.models, function (model) {
                                return model.get('choiceName');
                            }, this)

                            //If there are choices existing that aren't included in custom field choices, then push them
                            if (choices.length > 0) {
                                customChoices.unshift(...choices);
                            }

                            // Finish setting choices
                            parameterObject.set('choices', customChoices);
                        }
                        this.parameters.add(parameterObject);

                        // Needs to use callback due to render timing issues. Will use callback if it is the last extra parameter
                        if (index + 1 === extraParamsArray.length && typeof callback === 'function') {
                            callback(this.parameters);
                        }
                    }, this);

                    if (customField && !customField.isFetched) {
                        customField.fetch({
                            success: _.bind(function () {
                                fnRender();
                            }, this)
                        })
                    } else if (customField) {
                        fnRender();
                    }
                }
                // Parameter isn't a select input, so it is finished and can be pushed
                else {
                    this.parameters.add(parameterObject);

                    // Needs to use callback due to render timing issues. Will use callback if it is the last extra parameter
                    if (index + 1 === extraParamsArray.length && typeof callback === 'function') {
                        callback(this.parameters);
                    }
                }
            }, this)
        } else if (this.parameters) {
            if (typeof callback === 'function') {
                callback(this.parameters);
            }
        } else {
            callback(null);
        }
    },
});

PJQ.models.reports.ReportParameter = PJQ.models.BaseModel.extend({});

PJQ.collections.reports.ReportList = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.reports.Report,
    endpoint: function () {
        if (this.options.project) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'list'
                }
            ])
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'list'
                }
            ]);
        }
    }
});

PJQ.collections.reports.ReportParameters = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.reports.ReportParameter
});